module.exports = __webpack_public_path__ + "img/Canva-icon.063f0599.png";